import { RefObject, useEffect } from 'react'

type EventType = MouseEvent | TouchEvent

function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  handler: (event: EventType) => void
): void {
  useEffect(() => {
    const listener = (event: EventType) => {
      // Do nothing if clicking ref's element or its descendants
      if (!ref.current || (event.target instanceof Node && ref.current.contains(event.target))) {
        return
      }
      handler(event)
    }

    document.addEventListener('click', listener)

    return () => {
      document.removeEventListener('click', listener)
    }
  }, [ref, handler])
}

export default useClickOutside
